// Loading placeholder
const loadingPlaceholder = `
<div class="w-full h-full bg-gray-300 animate-pulse flex items-center justify-center">
    <span class="hero-photo text-gray-400 size-12"></span>
</div>
`

function getRetryDelay(retryCount: number): number {
  const baseDelay = 2000
  const maxJitter = 3000
  const exponentialDelay = baseDelay * Math.pow(2, retryCount)
  const jitter = Math.random() * maxJitter

  return exponentialDelay + jitter
}

async function checkImageAvailability(url: string): Promise<boolean> {
  try {
    const response = await fetch(url, { method: 'HEAD' })
    return response.ok && response.status === 200
  } catch {
    return false
  }
}

function createErrorHandler(wrapper: HTMLDivElement, image: HTMLImageElement) {
  let retryCount = 0

  return async function handleImageError() {
    if (retryCount >= 5) {
      return
    }

    // Show placeholder
    if (retryCount === 0) {
      wrapper.innerHTML = loadingPlaceholder
    }

    // Retry after delay
    setTimeout(async () => {
      const isAvailable = await checkImageAvailability(image.src)

      if (!isAvailable) {
        retryCount++
        handleImageError()
        return
      }

      const newImage = new Image()

      newImage.src = image.src
      newImage.className = image.className
      newImage.alt = image.alt

      newImage.onload = () => {
        wrapper.innerHTML = ''
        wrapper.appendChild(newImage)
      }

      newImage.onerror = () => {
        retryCount++
        handleImageError()
      }
    }, getRetryDelay(retryCount))
  }
}

export function screenshotRetrier() {
  document.querySelectorAll<HTMLDivElement>('.ts__screenshot_retrier').forEach((wrapper) => {
    const image = wrapper.querySelector<HTMLImageElement>('img')

    if (!image) {
      return
    }

    const errorHandler = createErrorHandler(wrapper, image)
    image.onerror = errorHandler
  })
}
